import React from "react";
import PropTypes from "prop-types";
import Form from "../common/Form";
import Section from "../common/Section";
import DossierFieldset from "./DossierFieldset";
import MinimaleEisenFieldset from "./MinimaleEisenFieldset";
import AdresFieldset from "./AdresFieldset";
import moment from "moment";

const SimulatieDossierForm = (props) => {
    const {
        disabled,
        onSave,
        onChange,
        onChangeRenovatieTable,
        onChangeVerdwijnendeInfrasTable,
        onChangeDossierSoort,
        onEditInfrastructuur,
        onAddInfrastructuur,
        onAddNieuwbouwInfrastructuur,
        onDeleteNieuwbouwInfrastructuur,
        simulatieDossier,
        soortenInfrastructuur,
		soortenInfrastructuurAll,
        gemeenten,
        postcodes,
        errors,
        validationMessageType,
        color,
        onSimuleer,
        disableSimuleer,
        mapKey,
        center,
        onGetGeoCoordinates,
        onReplacePoint,
        saveNewPoint,
        cancelReplace,
        inEditMode,
        newCoords,
        draggable,
        onClickTooltip,
        maxMapFeaturesToLoad,
        osmBaseLayerUrl,
        onMarkerDragEnd
    } = props;

    const dossierFieldsetProps = {
        naam: simulatieDossier ? simulatieDossier.naam : null,
        omschrijving: simulatieDossier ? simulatieDossier.omschrijving : null,
        disabled: disabled,
        onChange: onChange,
        errors: errors,
        validationMessageType: validationMessageType,
        naamLeidinggevende: simulatieDossier.naamLeidinggevende,
        email: simulatieDossier ? simulatieDossier.email : null,
        soortDossier: simulatieDossier ? simulatieDossier.soortDossier : null,
        verdwijnenErInfrastructuren: simulatieDossier ? simulatieDossier.verdwijnenErInfrastructuren : null,
        verdwijnenErInfrastructurenNietInSpakki: simulatieDossier ? simulatieDossier.verdwijnenErInfrastructurenNietInSpakki : null,
        onChangeDossierSoort: onChangeDossierSoort,
        sportinfrastructurenInDeBuurt: simulatieDossier ? simulatieDossier.sportinfrastructurenInDeBuurt : []
    };

    const MinimaleEisenFieldsetProps = {
        StartenWerkenNaUitersteIndieningsDatum: simulatieDossier.startenWerkenNaUitersteIndieningsDatum,
        HeeftAanvragerLangdurigZakelijkRecht: simulatieDossier.heeftAanvragerLangdurigZakelijkRecht,
        InfrastructuurOpengesteldVoorBreedPubliek: simulatieDossier.infrastructuurOpengesteldVoorBreedPubliek,
        InfrastructuurMarktconform: simulatieDossier.infrastructuurMarktconform,
        FinancieelDuurzaamEnHaalbaar: simulatieDossier.financieelDuurzaamEnHaalbaar,
        KanOmgevingsvergunningWordenBehaald: simulatieDossier.kanOmgevingsvergunningWordenBehaald,
        OpleveringBinnenDrieJaar: simulatieDossier.opleveringBinnenDrieJaar,
        IsHetProjectEnergetischDuurzaam: simulatieDossier.isHetProjectEnergetischDuurzaam,
        MinimaalGeinvesteerd: simulatieDossier.minimaalGeinvesteerd,
        typeDossier: simulatieDossier ? simulatieDossier.typeDossier : 0,
        disabled: disabled,
        onChange: onChange,
        errors: errors,
        validationMessageType: validationMessageType,
        UitersteIndiendatum: moment(simulatieDossier.uitersteIndiendatum).format("DD/MM/YYYY"),
        MinSportgerelateerdeInvesteringenExclBtw: simulatieDossier.minSportgerelateerdeInvesteringenExclBtw.toLocaleString(
            undefined,
            { minimumFractionDigits: 0 }
        )
    };

    const adresFieldsetProps = {
        onAddInfrastructuur: onAddInfrastructuur,
        onAddNieuwbouwInfrastructuur: onAddNieuwbouwInfrastructuur,
        onDeleteNieuwbouwInfrastructuur: onDeleteNieuwbouwInfrastructuur,
        simulatieDossier: simulatieDossier,
        disabled: disabled,
        gemeenten: gemeenten,
        postcodes: postcodes,
        errors: errors,
        validationMessageType: validationMessageType,
        onChange: onChange,
        onChangeRenovatieTable: onChangeRenovatieTable,
        onChangeVerdwijnendeInfrasTable: onChangeVerdwijnendeInfrasTable,
        onEditInfrastructuur: onEditInfrastructuur,
        onGetGeoCoordinates: onGetGeoCoordinates,
        mapKey: mapKey,
        center: center,
        soortenInfrastructuur: soortenInfrastructuur,
		soortenInfrastructuurAll: soortenInfrastructuurAll,
        onReplacePoint: onReplacePoint,
        saveNewPoint: saveNewPoint,
        cancelReplace: cancelReplace,
        inEditMode: inEditMode,
        newCoords: newCoords,
        draggable: draggable,
        onClickTooltip: onClickTooltip,
        maxMapFeaturesToLoad,
        osmBaseLayerUrl,
        onMarkerDragEnd
    };

    return (
        <Section title="Ga na of jouw dossier ontvankelijk is" color={color}>
            <Form title="Simulator (dossiergegevens)"
                name="simulator"
                leftButtonLabel="Bewaar"
                onLeftButtonClick={onSave}
                leftButtonDisabled={disabled}
                rightButtonLabel="Simuleer"
                onRightButtonClick={onSimuleer}
                rightButtonDisabled={disableSimuleer}>

                <DossierFieldset {...dossierFieldsetProps} />
                <MinimaleEisenFieldset {...MinimaleEisenFieldsetProps} />
                <AdresFieldset {...adresFieldsetProps} />
            </Form>
        </Section>
    );
};

SimulatieDossierForm.propTypes = {
    disabled: PropTypes.bool,
    onSimulate: PropTypes.func,
    onSave: PropTypes.func,
    simulatieDossier: PropTypes.object,
    soortenInfrastructuur: PropTypes.array,
	soortenInfrastructuurAll: PropTypes.array,
    onChange: PropTypes.func,
    onChangeRenovatieTable: PropTypes.func,
    onChangeVerdwijnendeInfrasTable: PropTypes.func,
    onChangeDossierSoort: PropTypes.func,
    onEditInfrastructuur: PropTypes.func,
    errors: PropTypes.object,
    validationMessageType: PropTypes.string,
    onAddInfrastructuur: PropTypes.func,
    onAddNieuwbouwInfrastructuur: PropTypes.func,
    onDeleteNieuwbouwInfrastructuur: PropTypes.func,
    gemeenten: PropTypes.array,
    postcodes: PropTypes.array,
    color: PropTypes.string,
    onSimuleer: PropTypes.func,
    disableSimuleer: PropTypes.bool,
    mapKey: PropTypes.string,
    center: PropTypes.object.isRequired,
    onGetGeoCoordinates: PropTypes.func.isRequired,
    newCoords: PropTypes.object,
    draggable: PropTypes.bool,
    onReplacePoint: PropTypes.func,
    saveNewPoint: PropTypes.func,
    cancelReplace: PropTypes.func,
    inEditMode: PropTypes.bool,
    onClickTooltip: PropTypes.func,
    maxMapFeaturesToLoad: PropTypes.string,
    osmBaseLayerUrl: PropTypes.string,
    onMarkerDragEnd: PropTypes.func
};

export default SimulatieDossierForm;
